import { render, staticRenderFns } from "./CustomerQuickAdd.vue?vue&type=template&id=21b3cf28&"
import script from "./CustomerQuickAdd.vue?vue&type=script&lang=js&"
export * from "./CustomerQuickAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports